import { ListItem, styled } from '@mui/material';

export const ListItemPosition = styled(ListItem)(() => ({
  marginLeft: '0px',
  paddingLeft: '0px'
}));
